/**
 * Shared tileset assets (case links and drawn custom tiles) that live outside the level document.
 * Lobby members apply each other's saves so Fix tiles / pick-a-sprite is live over the network.
 */
import { applyCustomSheet } from './customTiles.ts';
import { storeAssetLocally } from './remoteStore.ts';
import { setStyleOverride, type StyleOverride } from '../terrain/index.ts';

export const LOBBY_ASSET_KINDS = ['terrain-style', 'custom-tiles'] as const;
export type LobbyAssetKind = (typeof LOBBY_ASSET_KINDS)[number];

export function isLobbyAssetKind(kind: string): kind is LobbyAssetKind {
  return kind === 'terrain-style' || kind === 'custom-tiles';
}

/** Install a sheet or style override another lobby member just saved. */
export function applyLobbyAsset(kind: string, id: string, data: unknown): boolean {
  if (!isLobbyAssetKind(kind) || !data || typeof data !== 'object' || Array.isArray(data)) return false;
  try {
    storeAssetLocally(kind, id, data);
    if (kind === 'terrain-style') setStyleOverride(id, data as StyleOverride);
    else if (!applyCustomSheet(id, data)) return false;
    return true;
  } catch {
    return false;
  }
}
